export interface StockPanelRecentSearchesDropdownProps {
  searchTerms: string[];

  onClear: () => void;
  onTermClick: (term: string) => void;
}

/**
 * The server keeps up to 10 terms so typing can resurface searches older than the 3 the
 * dropdown shows; the frontend mirrors the cap for its optimistic in-memory copy.
 */
export const MAX_STORED_RECENT_SEARCHES = 10;
export const MAX_VISIBLE_RECENT_SEARCHES = 6;

export const RECENT_SEARCHES_DROPDOWN_OFFSET = 8;
